var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendOutlineIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essential Icons / send",
    clipPath: "url(#clip0_467_472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7737 1.44369C17.9832 1.65319 18.0541 1.96418 17.9563 2.24382L12.5576 17.6687C12.4531 17.9671 12.177 18.1716 11.8611 18.1845C11.5451 18.1974 11.2533 18.0161 11.1249 17.7271L8.16036 11.057L1.49024 8.0925C1.20127 7.96407 1.01998 7.67226 1.03287 7.3563C1.04576 7.04033 1.25022 6.76426 1.54869 6.65979L16.9735 1.26109C17.2532 1.16322 17.5642 1.23419 17.7737 1.44369ZM9.66455 10.6435L11.7443 15.323L15.3839 4.92414L9.66455 10.6435ZM14.2932 3.83344L3.89437 7.47304L8.57385 9.55281L14.2932 3.83344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5098,
    height: 18.5098,
    fill: "white",
    transform: "translate(0.260742 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutlineIco);
export default __webpack_public_path__ + "static/media/sendOutlineIco.d710ad8049fdad78bb58c2341e0c2fa5.svg";
export { ForwardRef as ReactComponent };